import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ModelNum, SchedeInterventoTeam, SchedeInterventoTeam_ExportModel } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class SchedeInterventoTeamService extends CrudGenericsService<SchedeInterventoTeam, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/SchedeInterventoTeam`);
    this.base = `${env.apiUrl}/api/SchedeInterventoTeam/`;
  }
  // web in tickets esporta in excel
  ExportSchedeIntervento_ByTiketsIds(model: ModelNum[]): Observable<SchedeInterventoTeam_ExportModel[]> {
    const u = `${this.base}ExportSchedeIntervento_ByTiketsIds`;
    return this.http.post<SchedeInterventoTeam_ExportModel[]>(u, model);
  }

  // ionic
  GetAll_ByIdSchedaIntervento(id: number): Observable<SchedeInterventoTeam[]> {
    const u = `${this.base}GetAll_ByIdSchedaIntervento?id=${id}`;
    return this.http.get<SchedeInterventoTeam[]>(u);
  }
  // ionic
  SaveAll_ByIdSchedaIntervento(model: SchedeInterventoTeam[], id: number) {
    const u = `${this.base}SaveAll_ByIdSchedaIntervento?id=${id}`;
    return this.http.post(u, model);
  }
}
